<template>
	<v-form>
		<v-text-field
			v-model="username"
			label="Name"
			required
		/>
		<v-text-field
			v-model="password"
			label="Password"
			type="password"
			required
		/>
		 <v-btn
			color="primary"
			:loading="loading"
			@click="login"
			type="submit"
		>
			Anmelden
		</v-btn>
		<v-snackbar v-model="showMessages" v-for="(message, index) in messages" v-bind="message" :key="index">
			{{message.message}}
		</v-snackbar>
	</v-form>
</template>

<script>
import user from '@/services/user.js';
export default {
	data() {
		return {username:"", password:"", messages: [], loading: false, showMessages: true}
	},
	methods: {
		login() {
			console.log("login")
			this.loading = true
			user.login(this.username, this.password).then(res => {
				this.$router.push({name: 'Home'})
				this.loading = false;
				this.messages.push({
					message: `Angemeldet as ${res}`
				})
			}).catch(e => {
				console.log("error")
				this.loading = false;
				this.messages.push({
					message: `Login failed: ${e}`,
					color: 'error'
				})
			})
		}
	}
}
</script>

<style>

</style>
